// eslint-disable-next-line no-restricted-imports
import {Portal as ChakraPortal, PortalProps} from "@chakra-ui/react";
import {useContext} from "react";
import {PortalContainerContext} from "./context";

type ExtraPortalProps = {
  /** Any child portals will use this container as their parent. */
  childContainer?: React.RefObject<HTMLElement>;
};

export const Portal = (props: React.PropsWithChildren<PortalProps> & ExtraPortalProps) => {
  const parentContainer = useContext(PortalContainerContext).ref;
  const {children, container, childContainer, ...rest} = props;

  return (
    <ChakraPortal {...rest} container={container ?? parentContainer}>
      <PortalContainerContext.Provider value={{ref: childContainer}}>{children}</PortalContainerContext.Provider>
    </ChakraPortal>
  );
};
